import { Component, OnInit, ViewContainerRef, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, DOCUMENT } from '@angular/common';
import { CruiseService } from '../services/cruise.service';
import { RechargeService } from '../services/recharge.service';
import { PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

// import { HttpClient, HttpEventType } from '@angular/common/http';
declare var jQuery: any;
declare var window: any;
declare var $: any; declare var Razorpay: any;
declare var moment: any;

@Component({
    selector: 'app-rechargeb2c',
    templateUrl: './rechargeb2c.component.html',
    styleUrls: ['./rechargeb2c.component.css'],
    providers: [CruiseService, DatePipe]
})
export class RechargeB2CComponent implements OnInit, AfterViewInit {

    public username: any; esimDeals: any[] = []; public pgCharges: any = { pgcharge: [{}] }; pgactive = "N"; public availableSIMS: any = [];
    public password: any; public planListarray: any = []; public planList: any = []; orgCnt: any = ""; orderId = ''; razorpay: any;
    public isAgentLoggedIn: any = false; private imageError: any = ''; public rechargeBundle: any = {}; public activationBundle: any = {};
    public portaltype: any = ''; public pgData: any; public promo: any; public promoapplied: any = 'No'; public totalpay: any;
    public promoOffer: any = { discount: 0 }; uploadamount: any = 0; public selectedGateway: any = ""; charges = 0;
    public email: any = ''; public circleName: any = ''; public operatorName: any = ''; public conveniencefee: any = 0;
    public Bookingref: any = ''; public Operatorslist: any = []; paymentType: string = 'upi'; vpa: string; finalData: any = '';
    card: any = {
        number: "",
        name: "",
        expMon: "",
        expYear: "",
        cvv: ""
    };
    netbanking: any = {
        bank: ''
    };
    public ticketUrls: any = ""; public rechargeData: any = {}; public registerStatus: any = [];
    public filename: any = ""; public circle: any = ''; public BillerID: any = ''; public operator: any = '';
    public trans: any = ""; netBankingOptions: any[] = []; walletOptions: any[] = []; wallet: string = '';
    public GSTNdiv: any = ''; public mobilenew: any = ""; public operatorSelect: any = ""; public planType: any = "";
    public Callagentremarks: any = ''; public availableMedia: any = []; public availableMediaLogo: any = [];
    public Callagentemail: any = ''; public amount: any = ""; public activationlist: any[]; public rechargelist: any[];
    public Callmobile: any = ''; public balancestr: any = 0; public hdfcUrl: any = ''; private transaction: any = '';
    private merchantsetup: any = {}; years: number[] = []; currentYear: number = new Date().getFullYear(); ZestMoney: string = '';
    private merchantsetups: any = {}; public availableOffers: any = [];
    fileData: File = null;
    previewUrl: any = null;
    fileUploadProgress: string = null;
    uploadedFilePath: string = null;
    public logo: any = "http://flights.ibe4all.com/images/logo.jpg";
    public fileUrl: any;
    public file: File = null; private base64string: any = ''; private fileName: any = ''; private baseURL: any = ''; private fullURL: any = '';
    public activationplan: any = ''; public sim: any = ''; public firstname: any = ''; public lastname: any = ''; public simNo: any = '';
    public postalcode: any = ''; public address1: any = ''; public address2: any = ''; public state: any = ''; paymentInitiate: any = "";
    public traveldate: any = ''; public passport: any = ''; public altmobile: any = ''; public visaimage: any = ''; public passportimage: any = ''; public ticketimage: any = '';
    // Labels
    public logintxt: any = 'Agent Sign In'; public signuptxt: any = 'Agent Sign Up'; public agent: any = {};
    public loginType = ''; private logindata: any = ''; private rooms: any = ''; public refcode: any; public agentcode: any = "";
    public contact: any = ''; memail: any = ''; mname: any = ''; public about: any = ''; AgentUserLoginId: any = ''; userType: any = '';
    public options: any = {
        autoApply: true,
        "locale": { "format": "DD/MM/YYYY" },
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment().format('DD-MM-YYYY'),
    };

    rechargeParam: any; rechargeCountry: any;

    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        private loginService: CruiseService, private toastr: ToastrService, private vcr: ViewContainerRef, private titleService: Title, private meta: Meta,
        public router: Router, platformLocation: PlatformLocation, private rechargeService: RechargeService, private datePipe: DatePipe, private route: ActivatedRoute, @Inject(DOCUMENT) private document: any) {
        this.baseURL = (platformLocation as any).location.origin; this.fullURL = (platformLocation as any).location.pathname;
        this.merchantsetup = this.loginService.getSetupData();
        this.loginType = this.loginService.getloginType();
        this.titleService.setTitle("International SIM cards, eSIMS and data solutions while traveling abroad");
        this.meta.addTag({ name: 'Description', content: "Your one-stop-shop for international SIM cards, eSIMS and data solutions while traveling abroad. Stay connected with our seamless, affordable, and reliable mobile connectivity wherever you go and enjoy free incoming. Explore our range of products and enjoy a worry-free travel experience." });
        this.meta.addTag({ name: 'Keywords', content: "International Sim Card | eSim | Prepaid Roaming Sim Card" });

        if (this.merchantsetup.portaltype == "B2B") {
            if (!sessionStorage.getItem("isAgentLoggedIn")) {
                this.router.navigate(["login"]);
            }
        }
        this.route.params.subscribe(params => {
            this.rechargeCountry = params["country"];
            this.titleService.setTitle("International SIM cards, eSIMS and data solutions for " + this.rechargeCountry);
            this.meta.addTag({ name: 'Keywords', content: "International Sim Card | eSim | Prepaid Roaming Sim Card | " + this.rechargeCountry });
            this.meta.addTag({ name: 'Description', content: "Your one-stop-shop for international SIM cards, eSIMS and data solutions while traveling in " + this.rechargeCountry + ". Stay connected with our seamless, affordable, and reliable mobile connectivity wherever you go and enjoy free incoming. Explore our range of products and enjoy a worry-free travel experience." });
        })

        if (sessionStorage.getItem("b2crechangePlan")) {
            this.rechargeParam = JSON.parse(sessionStorage.getItem("b2crechangePlan"));
            if (this.rechargeParam.activation == 'activation') {
                this.activationBundle = this.rechargeParam.data;
                this.activationBundle = this.activationBundle; this.activationplan = this.activationBundle.profile; this.amount = this.activationBundle.price; this.totalpay = this.amount;
            }
            if (this.rechargeParam.activation == 'recharge') {
                this.rechargeBundle = this.rechargeParam.data; this.activationBundle = this.rechargeBundle; this.activationplan = this.rechargeBundle.profile; this.amount = this.rechargeBundle.price; this.totalpay = this.amount;
            }
            this.rechargeCountry = this.rechargeParam.country; this.mobilenew = "";
            this.uploadamount = this.amount;
        }
        else {
            this.toastr.warning("Please select the Country and Plan, You are redirected...!");
            setTimeout(() => {
                this.router.navigate(["international-roaming"]);
            }, 2000);
        }
        // this.getExclusiveDeals("Exclusive Deals");

        this.razorpay = new Razorpay({
            key: 'rzp_live_m9dNIBFOnvX1zY',
        });

        this.razorpay.once('ready', (response) => {
            let methods = JSON.parse(JSON.stringify(response.methods.netbanking));
            this.netBankingOptions = Object.keys(methods).map(key => ({ type: key, value: methods[key] }));
            this.walletOptions = Object.keys(response.methods.wallet).map(key => ({ type: key, value: response.methods.wallet[key] }));
        })
        this.razorpay.checkPaymentAdapter('gpay')
            .then(() => {
                // Google Pay is available, show the payment option
                console.log("Gpay is available");
            })
            .catch(() => {
                console.log("Gpay is not available");
                // Google Pay is unavailable
            });
        for (let i = 0; i <= 20; i++) {
            this.years.push(this.currentYear + i);
        }

    }

    ngOnInit() {

        // try {
        //     if (!localStorage.getItem(this.baseURL + "media")) {
        //         this.getAvailableMedia();
        //     }
        //     else {
        //         this.availableMedia = JSON.parse(localStorage.getItem(this.baseURL + "media"));
        //         this.availableMedia = this.loginService.getpageMedia("international-roaming");
        //         // this.availableMedia = this.loginService.getpageMedia(this.fullURL);
        //         this.availableMediaLogo = this.loginService.getpageMedia('logo');
        //     }
        // } catch (error) { }

        try {
            if (this.availableMediaLogo.length == 0) {
                this.logo = "assets/images/logo.png";
            } else {
                this.logo = this.availableMediaLogo[0].ImageURL;
            }
        } catch (errormsg) { console.log(errormsg); }

        // setTimeout(() => {
        //     this.traveldate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
        // }, 1000);
        this.getActivationPlans(); this.getPaymentGatewayData(); this.getAvailableOffers();

        setTimeout(() => {
            jQuery('.owl-carousel.hero-bg-slideshow').owlCarousel({
                margin: 30,
                autoplay: true,
                loop: false,
                rewind: true,
                autoplayTimeout: 2000,
                lazyLoad: true,
                nav: true,
                navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
                responsive: {
                    0: { items: 1, },
                    576: { items: 1, },
                    768: { items: 1, },
                    992: { items: 1, }
                }
            });
        }, 500);
    }

    ngAfterViewInit() {
        $(".tab_content").hide();
        $(".tab_content:first").show();

        /* if in tab mode */
        $("ul.tabs li").click(function () {

            $(".tab_content").hide();
            var activeTab = $(this).attr("rel");
            $("#" + activeTab).fadeIn();

            $("ul.tabs li").removeClass("active");
            $(this).addClass("active");

            $(".tab_drawer_heading").removeClass("d_active");
            $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");

            /*$(".tabs").css("margin-top", function(){ 
               return ($(".tab_container").outerHeight() - $(".tabs").outerHeight() ) / 2;
            });*/
        });
        $(".tab_container").css("min-height", function () {
            return $(".tabs").outerHeight() + 50;
        });
        /* if in drawer mode */
        $(".tab_drawer_heading").click(function () {

            $(".tab_content").hide();
            var d_activeTab = $(this).attr("rel");
            $("#" + d_activeTab).fadeIn();

            $(".tab_drawer_heading").removeClass("d_active");
            $(this).addClass("d_active");

            $("ul.tabs li").removeClass("active");
            $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
        });
    }

    home() {
        this.router.navigate(["/"]);
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;

        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    onlyAlphabets(e: any) {
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
                return true;
            else
                return false;
        }
        catch (err) {
        }
    }

    // getAvailableMedia() {
    //     this.loginService.mediaContent("", "", "", "", 'Get', 'media').subscribe(
    //         data => {
    //             if (JSON.parse(JSON.stringify(data)).d) {
    //                 var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d).manageMedia;
    //                 localStorage.setItem(this.baseURL + "media", JSON.stringify(resp));
    //                 this.availableMedia = this.loginService.getpageMedia("international-roaming");
    //             }
    //         }
    //     )
    // }

    makeItBlank(event) {
        jQuery(event.target).val("");
    }

    // showPlanDetails() {
    //     // //billerid()circle()()()()()()()()()()()()()^&*Get^&*ezeeibe^&*fetchplans
    //     // this.planList = [];
    //     // for (let item of this.Operatorslist) {
    //     //   // if (item.OperatorName == this.operatorName) {
    //     //   var Circle = item.Circle; var BillerID = item.BillerID;
    //     //   break;

    //     // }
    //     // this.utilityService.fetchplans(BillerID, Circle, this.logintype, this.agentcode, this.agentid, 'Get', 'fetchplans').subscribe(
    //     //   data => {
    //     //     if (JSON.parse(JSON.stringify(data)).d) {
    //     //       var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d).data;
    //     //       this.planList = resp;
    //     //       // for (let item of this.planList) {
    //     //       //   var Circle = item.recharge_short_description;
    //     //       //   Circle==Circle;
    //     //       //   this.dropdownarray=item.recharge_short_description;
    //     //       // }
    //     //       //let arr = [];
    //     //       for (let i = 0; i < this.planList.length; i++) {
    //     //         if (!this.dropdownarray.includes(this.planList[i].recharge_short_description)) {
    //     //           this.dropdownarray.push(this.planList[i].recharge_short_description);
    //     //         }
    //     //       }
    //     //     }
    //     //   }
    //     // )
    // }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    ProceedRecharge($event) {
        if (!this.mobilenew) {
            this.toastr.warning("Please provide mobile ...!");
            return false;
        }
        if (!this.amount) {
            this.toastr.warning("Please select one of the Plans from List ...!");
            return false;
        }

        let d = {
            mobile: this.mobilenew,
            amount: this.amount,
            actionType: "recharge"
        };

        sessionStorage.setItem("b2crecharge", JSON.stringify(d)); this.pgactive = "Y";

        this.paymentInitiate = "initiate";

        // this.rechargeService.rechargePlan(this.mobilenew, JSON.stringify(this.rechargeBundle), JSON.stringify(this.logindata), this.agentcode, this.AgentUserLoginId, "Get", "recharge").subscribe(
        //     data => {
        //         if (JSON.parse(JSON.stringify(data)).d) {
        //             var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        //             if (resp1.Status == "Success") {
        //                 this.toastr.success(resp1.Message);
        //             } else { this.toastr.error(resp1.MessageData); }
        //             this.paymentInitiate = ""; this.amount = "";
        //         }
        //     }, error => {
        //         console.log("ProceedToPayment Error .....");
        //     }
        // )
    }

    ProceedActivation($event) {
        this.traveldate = jQuery('#flightDepart').val();
        if (!this.amount) {
            this.toastr.warning("Please select one of the Plans from List ...!");
            return false;
        }
        if (!this.firstname) {
            this.toastr.warning("First Name required ...!");
            return false;
        }
        if (!this.lastname) {
            this.toastr.warning("Last Name required ...!");
            return false;
        }
        if (!this.address1) {
            this.toastr.warning("Address required ...!");
            return false;
        }
        if (!this.state) {
            this.toastr.warning("State required ...!");
            return false;
        }
        if (!this.passport) {
            this.toastr.warning("Postal Code required ...!");
            return false;
        }
        if (!this.traveldate) {
            this.toastr.warning("Travel Date required ...!");
            return false;
        }
        // if (!this.visaimage) {
        //     this.toastr.warning("Visa Copy required ...!");
        //     return false;
        // }
        if (!this.passportimage) {
            this.toastr.warning("Passport Copy required ...!");
            return false;
        }
        // if (!this.ticketimage) {
        //     this.toastr.warning("Ticket Copy required ...!");
        //     return false;
        // }
        if (!this.sim) {
            this.toastr.warning("Select SIM type ...!");
            return false;
        }
        let d = {
            sim: this.sim,
            firstname: this.firstname,
            lastname: this.lastname,
            address1: this.address1,
            address2: (this.address2),
            state: this.state,
            postalcode: this.postalcode,
            passport: this.passport,
            traveldate: this.traveldate,
            visaimage: this.visaimage,
            passportimage: this.passportimage,
            ticketimage: this.ticketimage,
            refcode: this.refcode,
            simNo: this.simNo,
            altmobile: this.altmobile,
            email: this.email,
            actionType: "activation"
        };
        if ((this.amount > parseInt(this.balancestr)) && this.userType != "OO" && this.userType != "OOU") {
            this.toastr.warning("Wallet Balance in not enough. please top-up your Wallet...!");
            return false;
        }

        sessionStorage.setItem("b2crecharge", JSON.stringify(d)); this.pgactive = "Y";

        this.paymentInitiate = "initiate";
        // this.rechargeService.rechargePlan(this.mobilenew, JSON.stringify(this.activationBundle), JSON.stringify(this.logindata), JSON.stringify(d), this.AgentUserLoginId, "Get", "activate").subscribe(
        //     data => {
        //         if (JSON.parse(JSON.stringify(data)).d) {
        //             var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d);
        //             if (resp1.Status == "Success") {
        //                 this.toastr.success(resp1.MessageData);
        //             } else { this.toastr.error(resp1.MessageData); }
        //             this.paymentInitiate = ""; this.amount = "";
        //         }
        //     }, error => {
        //         console.log("ProceedToPayment Error .....");
        //     }
        // )
    }

    getActivationPlans() {
        this.rechargeService.fetchactivationplans("", "", "", "", "", 'Get', 'activationplans').subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.activationlist = resp;
                }
            }
        )
    }

    selectPlan(profile) {
        this.activationBundle = profile; this.activationplan = profile.profile; this.amount = profile.price;
    }

    readLogoFile(event: any, filetype) {
        var base64 = this.imgtobase64(event, filetype);
        if (base64 == false) {
            this.toastr.warning(this.imageError)
            return false;
        }
        // if (filetype == "visa") this.visaimage = this.base64string;
        // if (filetype == "passport") this.passportimage = this.base64string;
        // if (filetype == "ticket") this.ticketimage = this.base64string;
    }

    imgtobase64(fileInput: any, dataType: any) {
        this.imageError = ''; var cardImageBase64 = "";
        if (fileInput.target.files && fileInput.target.files[0]) {
            if (fileInput.target.files[0].name.toUpperCase().indexOf("PNG") > -1 || fileInput.target.files[0].name.toUpperCase().indexOf("JPEG") > -1 || fileInput.target.files[0].name.toUpperCase().indexOf("JPG") || fileInput.target.files[0].name.toUpperCase().indexOf("PDF") > -1) {
                // Size Filter Bytes
                const max_size = 2097152;

                if (fileInput.target.files[0].size > max_size) {
                    this.imageError =
                        'Maximum size allowed is ' + max_size / 1000000 + 'Mb';

                    return false;
                }

                this.filename = fileInput.target.files[0].name;

                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const imgBase64Path = e.target.result;
                    //console.log(imgBase64Path);
                    if (dataType == "visa") this.visaimage = this.base64string;
                    if (dataType == "passport") this.passportimage = this.base64string;
                    if (dataType == "ticket") this.ticketimage = this.base64string;
                    this.base64string = imgBase64Path;
                };
                reader.readAsDataURL(fileInput.target.files[0]);
            } else { this.toastr.warning("Choose the correct file. Need a Png,Jpeg file"); }
        }
    }

    getRechargePlans() {
        this.rechargeService.fetchactivationplans("", "", "", "", "", 'Get', 'rechargeplans').subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.rechargelist = resp;
                }
            }
        )
    }

    selectPlanRecharge(profile) {
        this.rechargeBundle = profile; this.amount = profile.price;
    }

    // agentbal() {
    //     if (this.loginType == "B2B") {
    //         this.logindata = (this.loginService.getAgentDecrypt());
    //         this.loginService.agentbalance(this.logindata.email, this.logindata.Type).subscribe(
    //             data => {
    //                 var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
    //                 if (resp.agentdata) {
    //                     this.balancestr = resp.agentdata.Balance;
    //                     sessionStorage.setItem("balance", JSON.stringify(resp.agentdata.Balance));
    //                 } else {
    //                     sessionStorage.setItem("balance", "0");
    //                 }
    //             },
    //             error => {
    //                 sessionStorage.setItem("balance", "0");
    //             }
    //         )

    //         this.balancestr = JSON.parse(sessionStorage.getItem("balance"));
    //     }
    // }

    getExclusiveDeals(cruise) {
        this.rechargeService.getrechargeOffers(cruise, "", this.loginType).subscribe(
            data => {
                let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                if (resp.status == 'success') {
                    this.esimDeals = resp.externalMaster;
                    setTimeout(() => {
                        $('.owl-carousel.banner').owlCarousel({
                            margin: 30,
                            autoplay: true,
                            autoplayTimeout: 2000,
                            lazyLoad: true,
                            rewind: true,
                            nav: true,
                            navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
                            responsive: {
                                0: { items: 1, },
                                576: { items: 2, },
                                768: { items: 3, },
                                992: { items: 4, }
                            }
                        });
                    }, 300);
                }
            },
            error => {
                console.log(error);
            }
        )
    }

    backselection() { this.router.navigate(["international-roaming"]); }

    getPaymentGatewayData() {
        this.loginService.getPGData("Upload").subscribe(
            data => {
                this.pgData = JSON.parse(JSON.parse(JSON.stringify(data)).d);
            },
            error => {
            }
        )
    }

    // Promo Code
    getAvailableOffers() {
        this.loginService.getAvailableOffers("Promo", "Recharge").subscribe(
            data => {
                this.availableOffers = JSON.parse(JSON.parse(JSON.stringify(data)).d);
            }
        )
    }

    applyPromo(promocode) {
        if (this.promo) {
            this.loginService.applyPromoCodeRecharge(this.promo, this.amount, "Recharge").subscribe(
                data => {
                    this.promoOffer = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (this.promoOffer.status == "failed") { this.toastr.warning(this.promoOffer.msg); } else {
                        if (this.promoOffer.discount > 0) {
                            this.toastr.success(this.promoOffer.msg); this.promoapplied = "Yes"; this.promoOffer.promo = this.promo;
                            this.totalpay = (this.charges - 0) + (this.uploadamount - 0) - (this.promoOffer.discount - 0);
                        }
                    }
                }, error => {

                }
            )
        } else {
            this.toastr.warning("Please apply promoCode");
        }
    }

    cancelPromo() {
        this.promo = '';
        this.promoOffer.promo = '';
        this.promoOffer.discount = 0;
        //this.promoOffer = ''; 
        this.promoapplied = "No"; this.totalpay = (this.charges - 0) + (this.uploadamount - 0) - (this.promoOffer.discount - 0);
    }


    offerp(offer) {
        this.promo = offer.PromoCode;
        this.applyPromo(this.promo);
    }

    PGSubmit(event) {
        if (!this.uploadamount) {
            this.toastr.warning("Please provide upload amount ....");
            return false;
        }
        if (this.selectedGateway == '') {
            this.toastr.warning("Please Select the Payment Option ....");
            return false;
        }
        if (!this.totalpay) {
            this.toastr.warning("Please provide upload amount ....");
            return false;
        }
        this.toastr.info("Please wait...! Do not referesh or press back button...!");
        var totalpay = (this.totalpay - 0);

        let p = {
            uploadamount: this.totalpay,
            selectedGateway: this.selectedGateway
        }

        let pax = {
            email: this.email,
            mobile: this.mobilenew
        }

        let discountInfo = {
            promocode: this.promo,
            promodiscount: this.promoOffer.discount
        }

        let data1 = sessionStorage.getItem("b2crecharge") + "()" + JSON.stringify(pax) + "()" + JSON.stringify(p) +
            "()" + JSON.stringify(discountInfo) + "()" + this.loginService.getloginType();

        if (this.rechargeParam.activation == 'activation') data1 += "()" + JSON.stringify(this.activationBundle);
        if (this.rechargeParam.activation == 'recharge') data1 += "()" + JSON.stringify(this.rechargeBundle);

        let data = window.btoa(unescape(encodeURIComponent(data1))) + "^&*" + "" + "^&*" + this.baseURL + "^&*rechargetransaction";
        this.rechargeService.makeFinalSubmission(data).subscribe(
            data => {
                let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                if (resp == '') {
                    this.toastr.warning("Some problem occurred during final submission...!")
                    return false;
                }
                else if (resp.status == 'failed') {
                    this.toastr.warning("Some problem occurred during final submission...!")
                    return false;
                }
                else {
                    sessionStorage.setItem("product", "recharge");
                    this.toastr.warning("Redirecting to Payment Gatway...!");
                    sessionStorage.setItem("paymentcontentN", JSON.stringify(totalpay));
                    sessionStorage.setItem("paxDetails", JSON.stringify(pax));
                    sessionStorage.setItem("promo", JSON.stringify(discountInfo));
                    if (this.rechargeParam.activation == 'activation') sessionStorage.setItem("bundle", JSON.stringify(this.activationBundle));
                    if (this.rechargeParam.activation == 'recharge') sessionStorage.setItem("bundle", JSON.stringify(this.rechargeBundle));
                    setTimeout(() => {
                        //this.routr.navigate(["confirm/wait/" + resp.TansactionKey]);
                        this.document.location.href = resp.PaymentLink;
                    }, 1000);
                };
            }, error => {
                this.toastr.info("Some problem occurred during final submission...!");
                console.log(error);
            }
        )
    }

    getsimNos(event, i?) {
        let term = event.target.value;
        {
            if (term.length > 2) {
                this.rechargeService.fetchactivationplans(term, "", "", "", "", 'Get', 'getesim').subscribe(
                    data => {
                        if (JSON.parse(JSON.stringify(data)).d) {
                            var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                            this.availableSIMS = resp.eSIM;
                        }
                    })
            }
        }
    }

    getOrderId(type, rechargeOption) {
        if (this.paymentInitiate != "initiate") {
            this.toastr.warning("Please Fill the Activation/Recharge Columns....");
            return false;
        }
        if (!this.uploadamount) {
            this.toastr.warning("Please provide upload amount ....");
            return false;
        }
        // if (this.selectedGateway == '') {
        //     this.toastr.warning("Please Select the Payment Option ....");
        //     return false;
        // }
        if (!this.totalpay) {
            this.toastr.warning("Please provide upload amount ....");
            return false;
        }
        this.toastr.info("Please wait...! Do not referesh or press back button...!");
        var totalpay = (this.totalpay - 0);

        let p = {
            uploadamount: this.totalpay,
            selectedGateway: this.selectedGateway
        }

        let pax = {
            email: this.email,
            mobile: this.mobilenew
        }

        let discountInfo = {
            promocode: this.promo,
            promodiscount: this.promoOffer.discount
        }

        let data1 = sessionStorage.getItem("b2crecharge") + "()" + JSON.stringify(pax) + "()" + JSON.stringify(p) +
            "()" + JSON.stringify(discountInfo) + "()" + this.loginService.getloginType();

        if (this.rechargeParam.activation == 'activation') data1 += "()" + JSON.stringify(this.activationBundle);
        if (this.rechargeParam.activation == 'recharge') data1 += "()" + JSON.stringify(this.rechargeBundle);

        sessionStorage.setItem("product", "recharge");
        sessionStorage.setItem("paymentcontentN", JSON.stringify(totalpay));
        sessionStorage.setItem("paxDetails", JSON.stringify(pax));
        sessionStorage.setItem("promo", JSON.stringify(discountInfo));
        if (this.rechargeParam.activation == 'activation') sessionStorage.setItem("bundle", JSON.stringify(this.activationBundle));
        if (this.rechargeParam.activation == 'recharge') sessionStorage.setItem("bundle", JSON.stringify(this.rechargeBundle));

        this.paymentType = type;
        this.loginService.generateOrderId((this.totalpay) * 100, "INR").subscribe(
            data => {
                let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                this.orderId = resp.orderID;
                this.pay();
            }, error => {
                this.toastr.error("Unable to process payment at the moment. Please try later.")
            }
        )
    }

    pay() {
        if (this.validatePaxDetails()) {
            if (this.paymentType == 'upi') {
                if (this.vpa) {
                    this.validateVPAAndPay();
                } else {
                    this.toastr.warning("VPA is required...!");
                    return false;
                }
            } else if (this.paymentType == 'card') {
                if (this.card.number && this.card.name && this.card.expMon && this.card.expYear & this.card.cvv) {
                    this.payViaCard();
                } else {
                    this.toastr.warning("Either Cvv, Exp Month or Year is missing...!")
                    return false;
                }
            } else if (this.paymentType == 'netbanking') {
                if (this.netbanking.bank) {
                    this.payViaNetBanking();
                } else {
                    this.toastr.warning("Please select a bank...!");
                    return false;
                }
            } else if (this.paymentType == 'wallet') {
                if (this.wallet) {
                    this.payViaWallet();
                } else {
                    this.toastr.warning("Please select a wallet...!");
                }
            }
            else if (this.paymentType == 'ZestMoney') {
                if (this.ZestMoney) {
                } else {
                    this.toastr.warning("Please select a wallet...!");
                }
            }
        }
        else { this.orderId = ""; }
    }

    validatePaxDetails() {
        if (!this.uploadamount) {
            this.toastr.warning("Please provide upload amount ....");
            return false;
        }
        if (this.selectedGateway == '') {
            this.toastr.warning("Please Select the Payment Option ....");
            return false;
        }
        if (!this.totalpay) {
            this.toastr.warning("Please provide upload amount ....");
            return false;
        }
        this.toastr.info("Please wait...! Do not referesh or press back button...!");
    }

    validateVPAAndPay() {
        this.razorpay.verifyVpa(this.vpa).then(() => {
            // if (this.validatePaxDetails()) {
            let option = {
                amount: (this.totalpay) * 100,
                email: this.email,
                contact: this.mobilenew,
                order_id: this.orderId,
                method: this.paymentType,
                upi: {
                    vpa: this.vpa,
                    flow: 'collect'
                }
            };
            this.triggerRazorPay(option);
            // }
        }).catch((e) => {
            console.log(e);
            this.toastr.warning(e.error.description);
        });
    }

    payViaCard() {

        let option = {
            amount: (this.totalpay) * 100,
            email: this.email,
            contact: this.mobilenew,
            order_id: this.orderId,
            method: this.paymentType,
            'card[name]': this.card.name,
            'card[number]': this.card.number,
            'card[cvv]': this.card.cvv,
            'card[expiry_month]': this.card.expMon,
            'card[expiry_year]': this.card.expYear
        };

        this.triggerRazorPay(option);

    }


    payViaNetBanking() {

        let option = {
            amount: (this.totalpay) * 100,
            email: this.email,
            contact: this.mobilenew,
            order_id: this.orderId,
            method: this.paymentType,
            bank: this.netbanking.bank
        }
        this.triggerRazorPay(option);

    }


    payViaWallet() {

        let option = {
            amount: (this.totalpay) * 100,
            email: this.email,
            contact: this.mobilenew,
            order_id: this.orderId,
            method: this.paymentType,
            wallet: this.wallet
        }

        this.triggerRazorPay(option);

    }

    triggerRazorPay(option) {
        let pax = {
            email: this.email,
            mobile: this.mobilenew
        }
        this.razorpay.createPayment(option);
        this.razorpay.on('payment.success', (resp) => {
            let paymentData = resp;
            this.loginService.verifyPaymentDetails(resp).subscribe(
                data => {
                    let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    this.finalData = {
                        pax: pax,
                        payment: paymentData,
                        netamount: this.totalpay
                    }
                    console.log(this.finalData);

                    if (this.rechargeParam.activation == 'activation') {
                        this.rechargeService.rechargePlan("", sessionStorage.getItem("bundle"), JSON.stringify(this.agent), sessionStorage.getItem("b2crecharge"), this.AgentUserLoginId, "Get", "activate").subscribe(
                            data => {
                                if (JSON.parse(JSON.stringify(data)).d) {
                                    var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                                    if (resp1.Status == "Success") {
                                        this.toastr.success(resp1.MessageData);
                                    } else { this.toastr.error(resp1.MessageData); }
                                }
                            }, error => {
                                console.log("ProceedToPayment Error .....");
                            }
                        )
                    }
                    else if (this.rechargeParam.activation == 'recharge') {
                        this.rechargeService.rechargePlan(this.mobilenew, sessionStorage.getItem("bundle"), JSON.stringify(this.agent), this.agentcode, this.AgentUserLoginId, "Get", "recharge").subscribe(
                            data => {
                                if (JSON.parse(JSON.stringify(data)).d) {
                                    var resp1 = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                                    if (resp1.Status == "Success") {
                                        this.toastr.success(resp1.Message);
                                    } else { this.toastr.error(resp1.MessageData); }
                                }
                            }, error => {
                                console.log("ProceedToPayment Error .....");
                            }
                        )
                    }

                },
                error => {
                    console.error(error);
                }
            )
        }); // will pass payment ID, order ID, and Razorpay signature to success handler.

        this.razorpay.on('payment.error', (resp) => {
            console.log(resp.error);
            this.toastr.error(resp.error.description); this.orderId = '';
            this.loginService.errorPaymentDetails(resp.error).subscribe(
                data => {
                    let resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                },
                error => {
                    console.error(error);
                }
            )
        });
    }

    changePaymentType(type) {
        this.paymentType = type;
    }
}